
import { useQuery } from '@tanstack/react-query';
import { loadTutorialMetadata, loadAllTutorialMetadata } from '@/utils/markdown-loader';
import { tutorials as staticTutorials, getTutorialById } from '@/utils/sample-data';

export function useTutorialMetadata(tutorialId?: string) {
  return useQuery({
    queryKey: ['tutorial', tutorialId],
    queryFn: async () => {
      if (!tutorialId) return null;
      
      try {
        const metadata = await loadTutorialMetadata(tutorialId);
        return metadata;
      } catch (error) {
        console.error(`Error fetching tutorial metadata for ${tutorialId}:`, error);
        // Fall back to static data
        return getTutorialById(tutorialId);
      }
    },
    enabled: !!tutorialId,
  });
}

export function useAllTutorials() {
  return useQuery({
    queryKey: ['tutorials'],
    queryFn: async () => {
      try {
        const tutorials = await loadAllTutorialMetadata();
        return tutorials.length > 0 ? tutorials : staticTutorials;
      } catch (error) {
        console.error('Error fetching all tutorials:', error);
        // Fall back to static data
        return staticTutorials;
      }
    }
  });
}
